export default class FileUploaderErrorType {
    static NOT_ALLOWED_FILE_SIZE = 0;
    static NOT_ALLOWED_FILE_TYPE = 1;
    static NOT_ALLOWED_FILE_COUNT = 2;
}
